import { MapTo } from '@adobe/cq-react-editable-components';
import React, { Component } from 'react';
import StrategyContainer from './StrategyContainer';

const StrategyContainerEditConfig = {
  emptyLabel: 'Modeling Container',

  isEmpty: function(props: any): boolean {
    return !props;
  },
};

class StrategyContainerWrapper extends Component {
  props: any;

  render(): JSX.Element {
    return <StrategyContainer {...this.props} />;
  }
}

export default MapTo('workplace-spa/components/strategycontainer')(
  StrategyContainerWrapper,
  StrategyContainerEditConfig,
);
